import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Candidate } from 'app/shared/models/candidate.model';
import { ModelManagement } from 'app/shared/models/modelmanagement.model';
import { ApiService } from 'app/shared/services/api.service';
@Component({
  selector: 'app-model-view',
  templateUrl: './model-view.component.html',
  styleUrls: ['./model-view.component.scss']
})

export class ModelViewComponent implements OnInit {
  task_id:any
  task:any
  currentUrl:any
  model_data = new ModelManagement()
  objectKeys = Object.keys;
 constructor(private apiService:ApiService,private activatedroute:ActivatedRoute) { 
  this.currentUrl=this.activatedroute.snapshot.routeConfig.path
  console.log('',this.currentUrl)
     this.activatedroute.paramMap.subscribe(params => { 
       this.task_id = params.get('id'); 
       
        this.getModelById(this.task_id)
       
   });
 
   }
 
   ngOnInit(): void {
     
   }
   
  getModelById(id){
    this.apiService.getModelManagementById(id).subscribe((res:any)=>{
        this.model_data=res?.data[0]

    })
  }
}

